<template>
    <div :id="'accordion' + index">
        <div
            class="card accordion"
            v-for="(item, idx) in childrens"
            :key="idx"
        >
            <div
                class="card-header"
                :id="'heading' + item.id + index"
                data-toggle="collapse"
                :data-target="'#collapse' + item.id + index"
                :aria-expanded="index == 0 && numChilds == 1"
                :aria-controls="'collapse' + item.id + index"
            >
                <div class="row no-gutters">
                    <div
                        class="col"
                        :class="{ 'tbl-column-disabled': !item.status }"
                    >
                        {{ item.name }}
                    </div>
                    <column-actions
                        v-if="checkActions"
                        tag="div"
                        class="col-auto d-flex justify-content-end"
                        listClass="actions"
                        :routeEdit="routeGroupEdit"
                        @delete="deleteItem"
                        deleteMsgTemplate="global.msg.confirm.delete-group"
                        :canDetail="canDetail"
                        :canEdit="canEdit"
                        :canDelete="canDelete"
                        :row="item"
                        :index="idx"
                        :callbackDelete="onRemove"
                    />
                </div>
            </div>
            <div
                :id="'collapse' + item.id + index"
                class="collapse"
                :class="{ show: index == 0 && numChilds == 1 }"
                :aria-labelledby="'heading' + item.id + index"
                :data-parent="'#accordion' + index"
            >
                <div class="card-body">
                    <table-data
                        :showTitleData="false"
                        :data="children(item.children)"
                        :settings="table.settings"
                        :columns="table.columns"
                        tableWrapperClass="table-responsive"
                        :inlineFilters="table.filters"
                        :autoUpdateFilter="table.autoUpdateFilter"
                        :addParamsToUrl="table.addParamsToUrl"
                        :loadingMsg="table.loadingMsg"
                        :notFoundMsg="table.notFoundMsg"
                        :orderByTemplate="table.orderByTemplate"
                        :showPagination="table.showPagination"
                        :tableInline="table.tableInline"
                        :isRecursive="true"
                        @error-load="showError"
                    >
                        <template v-slot:body="{ row, index, remove }">
                            <!-- <td class="text-nowrap">{{row.icon}}</td> -->
                            <td
                                class=""
                                :class="{ 'tbl-column-disabled': !row.status }"
                            >
                                {{ row.name }}
                            </td>
                            <column-actions
                                v-if="checkActions"
                                :routeEdit="routeItemEdit"
                                @delete="deleteItem"
                                :canDetail="canDetail"
                                :canEdit="canEdit"
                                :canDelete="canDelete"
                                :row="row"
                                :index="index"
                                :callbackDelete="remove"
                            />
                        </template>
                    </table-data>

                    <recursive-list
                        v-if="item.children.length > 0"
                        :list="item.children"
                        :checkActions="checkActions"
                        :routeItemEdit="routeItemEdit"
                        :routeGroupEdit="routeGroupEdit"
                        :moduleId="moduleId"
                        :canDetail="canDetail"
                        :canEdit="canEdit"
                        :canDelete="canDelete"
                        :onRemove="onRemove"
                        :deleteItem="deleteItem"
                        :table="table"
                        :showError="showError"
                        :index="index + 1"
                        :pageCode="pageCode"
                        :targetField="targetField"
                        class="mb-3"
                    >
                    </recursive-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        ColumnActions: () => import(/* webpackChunkName: "column-actions" */ "@/app/shared/components/tables/ColumnActions"),
        TableData: () => import(/* webpackChunkName: "table-data" */ "@/app/shared/components/tables/DataTable")
    },
    name: "RecursiveList",
    props: {
        moduleId: {
            type: String,
            required: true
        },
        routeGroupEdit: {
            type: String,
            required: false,
            default: null
        },
        routeItemEdit: {
            type: String,
            required: false,
            default: null
        },
        list: {
            type: [Object, Array],
            required: true,
            default: () => ({})
        },
        level: {
            type: Number,
            default: 1
        },
        checkActions: {
            type: Boolean,
            default: false
        },
        canDetail: {
            type: Boolean,
            default: false
        },
        canEdit: {
            type: Boolean,
            default: false
        },
        canDelete: {
            type: Boolean,
            default: false
        },
        onRemove: {
            type: Function,
            default: () => {}
        },
        deleteItem: {
            type: Function,
            default: () => {}
        },
        table: {
            type: Object,
            default: () => ({})
        },
        showError: {
            type: Function,
            default: () => {}
        },
        index: {
            type: Number,
            default: 0
        },
        pageCode: {
            type: String,
            required: true
        },
        targetField: {
            type: [String, Array],
            required: true
        }
    },
    computed: {
        childrens() {
            return this.list.filter(item => {
                return this.isGroup(item);
            });
        },
        numChilds() {
            return this.childrens.length;
        }
    },
    data() {
        return {};
    },
    methods: {
        children(list) {
            return list.filter(item => {
                return !this.isGroup(item);
            });
        },
        isGroup(item) {
            return item.behavior == "group";
        }
    }
};
</script>

<style></style>
